export default __webpack_public_path__ + "static/media/2.38e787b1.jpg";